<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="small-panel" @click.stop>
                <div class="dialog-title" v-t="'message.action_create_group'"></div>
                <hr class="dialog-hr">
                <div class="dialog-body-small" ref="modalBody">
                    <el-form label-width="220px" >
                        <div class="dialg-form-item"></div>
                        <!--- グループID --->
                        <el-form-item ref="talkgroupName" prop="talkgroupName">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_groupId'"></span> <span class="required" v-t="'message.item_required'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_groupId')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-input id="talkgroupName" class="input-text-talkgroup" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.talkgroupName.value"
                                 @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                 clearable @clear="InputCheckAll()"/>
                        </el-form-item>
                        <!--- グループ表示名 --->
                        <el-form-item ref="displayName" prop="displayName">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_groupDisplayName'"></span> <span class="required" v-t="'message.item_required'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_group_displayName')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-input id="displayName" class="input-text-talkgroup" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.displayName.value"
                                 @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                 clearable @clear="InputCheckAll()"/>
                        </el-form-item>
                        <!--- 通話データ保存 --->
                        <el-form-item prop="saveVoice" ref="saveVoice">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_save_voice'"></span> <span class="required" v-t="'message.item_required'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_save_voice')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-tooltip :content="$t('message.hint_option_not_available_when_encrypted')" placement="top" :disabled="!appData.e2eEncryption">
                                <el-select class="select-option-item" v-model="groupOptions.saveVoice" :disabled="appData.e2eEncryption">
                                    <el-option v-for="saveOption in saveOptions" :key="saveOption.displayName" :label="saveOption.displayName" :value="saveOption.value"></el-option>
                                </el-select>
                            </el-tooltip>
                        </el-form-item>
                        <!--- データの保存先 --->
                        <el-form-item prop="storageSelection" ref="storageSelection">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_data_storage'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_storage_selection')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-select class="select-option-item" v-model="selectedStorageIndex" @change="setButtonStatus()" :disabled="storageCandidates.length == 1">
                                <el-option v-for="(candidate, index) in storageCandidates" :key="candidate.name" :label="candidate.name" :value="index"></el-option>
                            </el-select>
                        </el-form-item>
                        <!--- リージョン --->
                        <!---el-form-item ref="region" prop="region">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_region'"></span> <span class="required" v-t="'message.item_required'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_group_region')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-select class="select-option-item" v-model="inputForm.region.value" @change="handleChangeRegion()">
                                <el-option v-for="region in regions" :key="region.regionName" :label="region.displayName" :value="region.regionName"></el-option>
                            </el-select>
                        </el-form-item-->
                        <!--- 通話自動終了 --->
                        <el-form-item ref="durationLimit" prop="durationLimit">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_talk_timer'"></span> <span class="required" v-t="'message.item_required'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-t="'message.hint_talk_timer1'"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-input id="durationLimit" class="input-text-talkgroup" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.durationLimit.value"
                                 @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                 clearable @clear="InputCheckAll()"/>
                        </el-form-item>
                        <!--- スキマ発話再生待機 --->
                        <el-form-item v-if="FEATURE_BD_2018_RESERVE_TALK && isReserveTalkAppsEnabled" ref="reserveTalkPlaybackWait" prop="reserveTalkPlaybackWait">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_reserve_talk_playback_wait'"></span> <span class="required" v-t="'message.item_required'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-t="'message.hint_reserve_talk_playback_wait'"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-input id="reserveTalkPlaybackWait" class="input-text-talkgroup" type="text" :disabled="isReserveTalkPlaybackWaitDisabled" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.reserveTalkPlaybackWait.value"
                                 @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                 clearable @clear="inputCheck('reserveTalkPlaybackWait')"/>
                        </el-form-item>
                        <!--- 通話形式 --->
                        <el-form-item prop="talkType" ref="talkType">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_talk_type'"></span> <span class="required" v-t="'message.item_required'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_talk_type')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-select class="select-option-item" v-model="talkType">
                                <el-option v-for="talkType in talkTypeList" :label="talkType.label" :value="talkType.value"></el-option>
                            </el-select>
                        </el-form-item>
                        <!--- かんたんログイン --->
                        <el-form-item style="text-align:right">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_option_easyLogin'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_easy_login_selection')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-switch v-model="easyLogin" active-color="#5171cb" @change="handleOptionChange('easyLogin')"></el-switch>
                        </el-form-item>
                        <!--- 低ビットレート --->
                        <el-form-item style="text-align:right">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_option_lowBitRate'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-t="'message.hint_option_lowBitRate'"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-switch v-model="groupOptions.lowBitRate" active-color="#5171cb" @change="handleOptionChange('lowBitRate')"></el-switch>
                        </el-form-item>
                        <!--- 位置情報オプション --->
                        <el-form-item v-if="isVisibleGroupOption('location')" style="text-align:right">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_option_location_information'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-t="'message.hint_option_locationInGroup'"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-switch v-model="groupOptions.location" active-color="#5171cb" @change="handleOptionChange('location')"></el-switch>
                        </el-form-item>
                        <!--- マップ通話オプション --->
                        <el-form-item v-if="isVisibleGroupOption('mapTalk')" style="text-align:right">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_option_map_talk'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-t="'message.hint_option_map_talk'"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-switch v-model="groupOptions.mapTalk" active-color="#5171cb" @change="handleOptionChange('mapTalk')"></el-switch>
                        </el-form-item>
                        <!--- サブグループオプション --->
                        <el-form-item v-if="appData.enableSubgroupOption" style="text-align:right">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_option_subGroup'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-t="'message.hint_option_subGroup'"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-switch v-model="groupOptions.subGroup" active-color="#5171cb" @change="handleOptionChange('subGroup')"></el-switch>
                        </el-form-item>

                        <template v-if="showOptionSetting">
                            <!--- hide all options when online purchase / speech-to-text license not exist ---->
                            <!--- 有償オプションの説明 --->
                            <p class="beside-line" v-t="'message.item_option'"></p>
                            <p class="option-description">
                                <span v-if="appData.basicContract.planType == 0" v-t="'message.hint_option_description1'"/>
                                <span v-else v-t="'message.hint_option_description1_plan'"/>
                                <br>
                                <span v-t="'message.hint_option_description3'"/><br>
                                <span>
                                    <span v-t="'message.hint_option_description7_1'"/>
                                    <a href="javascript:void(0);" style="text-decoration:none" @click="$emit('showManual')"><span v-t="'message.menu_manual'"/></a>
                                    <span v-t="'message.hint_option_description7_2'"/>
                                </span>
                            </p>

                            <!--- 音声テキスト化オプション --->
                            <el-form-item v-if="isVisibleGroupOption('speechToTextEngine')" style="text-align:right">
                                <div slot="label" style="text-align:left">
                                    <span v-t="'message.item_option_speechToText'"></span>
                                    <el-tooltip effect="dark" placement="top-start">
                                        <div slot="content" style="text-align:left" v-t="'message.hint_option_speechToText'"></div>
                                        <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                    </el-tooltip>
                                </div>
                                <el-tooltip :content="$t('message.hint_option_not_available_when_encrypted')" placement="top" :disabled="!appData.e2eEncryption">
                                    <el-select class="select-option-item" v-model="groupOptions.speechToTextEngine" @change="handleOptionChange('speechToTextEngine')" :disabled="appData.e2eEncryption">
                                        <el-option v-for="speechEngine in speechEngineList" :key="speechEngine.type" :label="speechEngine.displayName" :value="speechEngine.type">
                                            <template v-if="speechEngine.tooltip">
                                                <span style="float: left; margin-right: 4px;">{{ speechEngine.displayName }}</span>
                                                <el-tooltip effect="dark" placement="top-start">
                                                    <div slot="content" style="text-align:left" v-html="speechEngine.tooltip"></div>
                                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                                </el-tooltip>
                                            </template>
                                        </el-option>
                                    </el-select>
                                </el-tooltip>
                            </el-form-item>
                            <!--- 音声テキスト化対応言語 --->
                            <div class="language-option-container">
                                <div class="language-header">
                                    <span class="language-title" v-t="'message.manual_item_language'" v-on:click="sttExpanded = !sttExpanded" style="cursor: pointer;"></span>
                                    <button v-if="!sttExpanded" class="transparent" type="button" v-on:click="sttExpanded = true"><i class="el-icon-arrow-down"></i></button>
                                    <button v-else class="transparent" type="button" v-on:click="sttExpanded = false"><i class="el-icon-arrow-up"></i></button>
                                </div>
                                <template v-if="sttExpanded">
                                    <div class="engine-list">
                                        <div class="engine-item" v-for="(engine, index) in sttEngineDescriptions" :key="index">
                                            <div class="engine-name">
                                                <span v-t="engine.name"></span>
                                            </div>
                                            <div class="engine-description">
                                                <span v-t="engine.description"></span>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>
                            <!--- 翻訳オプション --->
                            <el-form-item v-if="isVisibleGroupOption('translationEngine')" style="text-align:right">
                                <div slot="label" style="text-align:left">
                                    <span v-t="'message.item_option_translation'"></span>
                                    <el-tooltip effect="dark" placement="top-start">
                                        <div slot="content" style="text-align:left" v-html="$t('message.hint_option_translation')"></div>
                                        <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                    </el-tooltip>
                                </div>
                                <el-tooltip :content="$t('message.hint_option_not_available_when_encrypted')" placement="top" :disabled="!appData.e2eEncryption">
                                    <el-select class="select-option-item" v-model="groupOptions.translationEngine" @change="handleOptionChange('translationEngine')" :disabled="appData.e2eEncryption">
                                        <el-option v-for="translationEngine in translationEngineList" :key="translationEngine.type" :label="translationEngine.displayName" :value="translationEngine.type"></el-option>
                                    </el-select>
                                </el-tooltip>
                            </el-form-item>
                            <!--- 翻訳対応言語 --->
                            <div class="language-option-container">
                                <div class="language-header">
                                    <span class="language-title" v-t="'message.manual_item_language'" v-on:click="translationExpanded = !translationExpanded" style="cursor: pointer;"></span>
                                    <button v-if="!translationExpanded" class="transparent" type="button" v-on:click="translationExpanded = true"><i class="el-icon-arrow-down"></i></button>
                                    <button v-else class="transparent" type="button" v-on:click="translationExpanded = false"><i class="el-icon-arrow-up"></i></button>
                                </div>
                                <template v-if="translationExpanded">
                                    <div class="engine-list">
                                        <div class="engine-item" v-for="(engine, index) in translationEngineDescriptions" :key="index">
                                            <div class="engine-name">
                                                <span v-t="engine.name"></span>
                                            </div>
                                            <div class="engine-description">
                                                <span v-t="engine.description"></span>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>

                            <template v-if="isVisibleGroupOption('video')">
                                <!--- ライブキャストオプション --->
                                <el-form-item style="text-align:right">
                                    <div slot="label" style="text-align:left">
                                        <span v-t="'message.item_option_video'"></span>
                                        <el-tooltip effect="dark" placement="top-start">
                                            <div slot="content" style="text-align:left" v-t="'message.hint_option_video'"></div>
                                            <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                        </el-tooltip>
                                    </div>
                                    <el-switch v-model="groupOptions.video" active-color="#5171cb" @change="handleOptionChange('video')"></el-switch>
                                </el-form-item>
                                <!--- ライブキャスト保存 --->
                                <el-form-item prop="saveLivecast" ref="saveLivecast">
                                    <div slot="label" style="text-align:left">
                                        <span v-t="'message.item_save_livecast'"></span>
                                        <el-tooltip effect="dark" placement="top-start">
                                            <div slot="content" style="text-align:left" v-html="$t('message.hint_save_livecast')"></div>
                                            <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                        </el-tooltip>
                                    </div>
                                    <el-tooltip :content="$t('message.hint_option_not_available_when_encrypted')" placement="top" :disabled="!appData.e2eEncryption">
                                        <el-select class="select-option-item" :disabled="appData.e2eEncryption || !groupOptions.video" v-model="groupOptions.saveLivecast">
                                            <el-option v-for="saveOption in saveOptions" :key="saveOption.displayName" :label="saveOption.displayName" :value="!appData.e2eEncryption && saveOption.value"></el-option>
                                        </el-select>
                                    </el-tooltip>
                                </el-form-item>
                                <!--- ライブキャスト自動終了 --->
                                <el-form-item ref="videoDurationLimit" prop="videoDurationLimit">
                                    <div slot="label" style="text-align:left">
                                        <span v-t="'message.item_video_timer'"></span>
                                        <el-tooltip effect="dark" placement="top-start">
                                            <div slot="content" style="text-align:left" v-t="{ path: 'message.hint_video_timer', args: { max: getMaxVideoDurationLimit() } }"></div>
                                            <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                        </el-tooltip>
                                    </div>
                                    <el-input id="videoDurationLimit" class="input-text-talkgroup" type="text" :disabled="!groupOptions.video" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.videoDurationLimit.value"
                                        @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                        clearable @clear="inputCheck('videoDurationLimit')"/>
                                </el-form-item>
                            </template>
                        </template>
                        <!--- 高度な設定　--->
                        <div v-if="enableDisconnectAlertGroup()" class="toggle-beside-line" @click="toggleAdvancedSettings">
                            <span v-t="isAdvancedSettingsVisible ? 'message.item_option_advanced_close' : 'message.item_option_advanced_open'"></span>
                            <span class="toggle-arrow" :class="{ 'open': isAdvancedSettingsVisible }">▼</span>
                        </div>
                        <!--- 高度な設定 切断検知グループ --->
                        <div v-if="isAdvancedSettingsVisible" class="advanced-settings" ref="advancedSettings">
                            <el-form-item v-if="enableDisconnectAlertGroup()" style="text-align:right">
                                <div slot="label" style="text-align:left">
                                    <span v-t="'message.item_option_alertMode'"></span>
                                    <el-tooltip effect="dark" placement="top-start">
                                        <span slot="content" style="text-align:left" v-t="'message.hint_option_alert_mode'"></span>
                                        <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                    </el-tooltip>
                                </div>
                                <el-switch v-model="groupOptions.disconnectAlert" active-color="#5171cb" @change="handleOptionChange('disconnectAlert')"></el-switch>
                            </el-form-item>
                            <div style="color: red" v-t="'message.info_alert_group'"></div>
                        </div>
                    </el-form>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" @click="addTalkgroup" :disabled="this.$data.disableButton" v-t="'message.button_save'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import commonUtil from './commonutil.js';
import commonValidate from './common-validate.js';
import constants from './constants.js';
import server from './ServerApi.js';
import processorTemplateUtil from './pc/setting/ai-app/AiAppSettingUtil.js';
import { FEATURE_BD_2018_RESERVE_TALK } from "@/components/feature_toggles/feature_toggle";
import { FEATURE_BD_1862_LONG_LIVECAST } from "@/components/feature_toggles/feature_toggle";

export default {
    data() {
        return {
            regions: null,
            speechEngineList: [],
            translationEngineList: [],
            saveOptions: [],
            storageCandidates: [],
            talkTypeList: [],
            easyLogin: false,
            isAdvancedSettingsVisible: false,

            disableButton: true,
            sttExpanded: false,
            translationExpanded: false,
            sttEngineDescriptions: (this.appData.basicContract.planType != 0) ?
            [
                { name: 'message.item_auto', description: 'message.hint_stt_engine_auto' },
                { name: 'message.item_amivoice', description: 'message.hint_stt_engine_amivoice' },
                { name: 'message.item_azure_speechToText', description: 'message.hint_stt_engine_azure' }
            ] :
            [
                { name: 'message.item_auto', description: 'message.hint_stt_engine_auto' },
                { name: 'message.item_amivoice', description: 'message.hint_stt_engine_amivoice' },
                { name: 'message.item_azure_speechToText', description: 'message.hint_stt_engine_azure' },
                { name: 'message.item_google_speechToText', description: 'message.hint_stt_engine_google' }
            ],
            translationEngineDescriptions: [
                { name: 'message.item_auto', description: 'message.hint_translation_engine_auto' },
                { name: 'message.item_azure_translate', description: 'message.hint_translation_engine_azure' },
                { name: 'message.item_google_translate', description: 'message.hint_translation_engine_google' },
                { name: 'message.item_deepl_translate', description: 'message.hint_translation_engine_deepl' }
            ],

            inputForm: {
                talkgroupName:              { validationRule: "objectId",       valid: false, value: null,   isComposing: false },
                displayName:                { validationRule: "reqDisplayName", valid: false, value: null,   isComposing: false },
                region:                     { validationRule: "selectItem",     valid: true,  value: "AUTO",　isComposing: false },
                durationLimit:              { validationRule: "numeric",        valid: true,  value: 60,     isComposing: false },
                videoDurationLimit:         { validationRule: "numeric",        valid: true,  value: 60,     isComposing: false },
                reserveTalkPlaybackWait:    { validationRule: "numeric",        valid: true,  value: 3,      isComposing: false },
            },
            talkType: null,
            groupOptions: {
                speechToTextEngine:     0,
                translationEngine:      0,
                saveVoice:              !this.appData.e2eEncryption,
                saveLivecast:           false,
                mapTalk:                false,
                video:                  false,
                lowBitRate:             false,
                subGroup:               false,
                easyLogin:              0,
                disconnectAlert:        false
            },
            savedEngine: {
                speechToTextEngine: 0,
                translationEngine: 0
            },
            selectedStorageIndex: 0,
        };
    },
    created: function() {
        if (this.appData.basicContract.planType != 0) {
            this.speechEngineList = commonUtil.getSpeechToTextEngineListForPlanLicense(this.$i18n);
        } else {
            this.speechEngineList = commonUtil.getSpeechToTextEngineList(this.$i18n);
        }
        this.translationEngineList = commonUtil.getTranslationEngineList(this.$i18n);
        this.saveOptions = commonUtil.getSaveOptions(this.$i18n);
        // this.getRegions();

        // selection of storage
        let storageCandidatesAndIndex = processorTemplateUtil.createStorageCandidateArray(this.$i18n, this.$root.store.processorDefinitionList, null);
        this.storageCandidates = storageCandidatesAndIndex.storageCandidates;

        this.talkTypeList = commonUtil.getTalkTypeList(this.$i18n);
    },
    watch: {
    },
    computed: {
        FEATURE_BD_2018_RESERVE_TALK() {
            return FEATURE_BD_2018_RESERVE_TALK;
        },
        FEATURE_BD_1862_LONG_LIVECAST() {
          return FEATURE_BD_1862_LONG_LIVECAST;
        },
        isReserveTalkAppsEnabled() {
            return commonUtil.isReserveTalkEnabled(this.appData.apps);
        },
        isReserveTalkPlaybackWaitDisabled: function() {
            return !commonUtil.isReserveTalkEnabled(this.appData.apps);
        },
        showOptionSetting: function() {
            if (this.appData.onlinePurchase) {
                if (this.appData.basicContract.planType != constants.LICENSE_PLAN_SEPARATE) {
                    return true
                } else {
                    if (this.appData.isRadioIntegrated
                        || (this.appData.enableSpeechTextOption)
                        || (this.appData.enableSpeechTextTrial)) {
                        return true;
                    } else {
                        return false;
                    }
                }
            } else {
                return true;
            }
        },
    },
    mounted: function() {
        // tabIndex of tooltip was always set to 0 (Should set -1 to skip focus)
        for (let element of document.getElementsByClassName('icon-help')) {
            element.setAttribute("tabIndex", "-1");
        }
    },
    methods: {
        isLongLivecastEnabled() {
            if (!this.FEATURE_BD_1862_LONG_LIVECAST) {
                return false;
            }
            return ((this.appData?.tenantOption ?? 0) & constants.LONG_LIVECAST) !== 0;
        },
        getMaxVideoDurationLimit() {
            return this.isLongLivecastEnabled() ? 14400 : 3600;
        },
        getVideoDurationUpperLimitMessage(maxDurationLimit) {
            return this.$t('message.error_validate_video_duration_higher_limit', { max: maxDurationLimit.toLocaleString() });
        },
        addTalkgroup: function() {
            let processorDefinitionIds = null;
            if (this.selectedStorageIndex > 0) {
                let processorDefinitionId = this.storageCandidates[this.selectedStorageIndex].value;
                processorDefinitionIds = [processorDefinitionId];
            }

            if (this.talkType != null) {
                this.groupOptions[this.talkType] = true;
            }

            // in talkgroup creation, there is only an ON/OFF button which can enable easy login type SELECTION.
            // in talkgroup modification, there is a dropdown menu in which we can select easy login type RANDOM, i.e. old version
            if (this.easyLogin) {
                this.groupOptions.easyLogin = constants.EASY_LOGIN_TYPE_SELECTION;
            }

            const addPayload = {
                        name: this.inputForm.talkgroupName.value,
                        displayName: this.inputForm.displayName.value,
                        region: this.inputForm.region.value,
                        talkgroupOptions: this.groupOptions,
                        durationLimit: this.inputForm.durationLimit.value,
                        videoDurationLimit: this.inputForm.videoDurationLimit.value,
                        processorDefinitionIds: processorDefinitionIds,
            };
            if (FEATURE_BD_2018_RESERVE_TALK && this.isReserveTalkAppsEnabled) {
                addPayload.reserveTalkPlaybackWait = this.inputForm.reserveTalkPlaybackWait.value;
            }
            this.$emit('add', addPayload);
        },
        setButtonStatus: function() {
            if (commonValidate.checkFormValidation(this.inputForm)) {
                this.disableButton = false;
            } else {
                this.disableButton = true;
            }
        },
        inputCheck(eventTargetId) {
            if (eventTargetId == "region") {
                return;
            }
            if (this.inputForm[eventTargetId].isComposing) {
                // inputting with IME
                return;
            }
            let validateResult = commonValidate.validateItem(this.$i18n, this.inputForm[eventTargetId].validationRule, this.inputForm[eventTargetId].value);
            if (validateResult.valid) {
                if (eventTargetId == "durationLimit" || eventTargetId == "videoDurationLimit") {
                    const maxDurationLimit = eventTargetId == "videoDurationLimit" ? this.getMaxVideoDurationLimit() : 3600;
                    if (this.inputForm[eventTargetId].value >= 1 && this.inputForm[eventTargetId].value <= maxDurationLimit) {
                        this.inputForm[eventTargetId].valid = true;
                        this.$refs[eventTargetId].clearValidate();
                    } else {
                        this.inputForm[eventTargetId].valid = false;
                        this.$refs[eventTargetId].validateState = "error";
                        if (this.inputForm[eventTargetId].value < 1) {
                            this.$refs[eventTargetId].validateMessage = commonUtil.getMessageText(this.$i18n,"error_validate_duration_lower_limit");
                        } else {
                            if (this.FEATURE_BD_1862_LONG_LIVECAST) {
                                this.$refs[eventTargetId].validateMessage = eventTargetId == "videoDurationLimit"
                                    ? this.getVideoDurationUpperLimitMessage(maxDurationLimit)
                                    : commonUtil.getMessageText(this.$i18n, "error_validate_duration_higher_limit");
                            } else {
                                this.$refs[eventTargetId].validateMessage = commonUtil.getMessageText(this.$i18n,"error_validate_duration_higher_limit");
                            }
                        }
                    }
                } else if (eventTargetId == "reserveTalkPlaybackWait") {
                    if (this.inputForm[eventTargetId].value >= constants.RESERVE_TALK_PLAYBACK_WAIT_MIN && this.inputForm[eventTargetId].value <= constants.RESERVE_TALK_PLAYBACK_WAIT_MAX) {
                        this.inputForm[eventTargetId].valid = true;
                        this.$refs[eventTargetId].clearValidate();
                    } else {
                        this.inputForm[eventTargetId].valid = false;
                        this.$refs[eventTargetId].validateState = "error";
                        if (this.inputForm[eventTargetId].value < constants.RESERVE_TALK_PLAYBACK_WAIT_MIN) {
                            this.$refs[eventTargetId].validateMessage = commonUtil.getMessageText(this.$i18n,"error_validate_reserve_talk_playback_wait_lower_limit");
                        } else {
                            this.$refs[eventTargetId].validateMessage = commonUtil.getMessageText(this.$i18n,"error_validate_reserve_talk_playback_wait_higher_limit");
                        }
                    }
                }
                 else {
                    this.inputForm[eventTargetId].valid = true;
                    this.$refs[eventTargetId].clearValidate();
                }
            } else {
                this.inputForm[eventTargetId].valid = false;
                this.$refs[eventTargetId].validateState = "error";
                this.$refs[eventTargetId].validateMessage = validateResult.message;
            }
            this.setButtonStatus();
        },
        InputCheckAll() {
            for (let targetId in this.inputForm) {
                this.inputCheck(targetId);
            }
        },
        compositionStart(eventTargetId) {
            this.inputForm[eventTargetId].isComposing = true;
        },
        compositionEnd(eventTargetId) {
            this.inputForm[eventTargetId].isComposing = false;
            this.inputCheck(eventTargetId)
        },
        handleChangeRegion() {
            this.setButtonStatus();
        },
        handleOptionChange(changedOption) {
            commonUtil.checkChangedGroupOptionCondition(this, changedOption, this.appData, this.groupOptions, this.savedEngine, false, false);
            switch (changedOption) {
                case "video":
                    if(!this.appData.e2eEncryption && this.groupOptions.video) {
                        this.groupOptions.saveLivecast = true
                    } else {
                        this.inputForm.videoDurationLimit.value = 60
                        this.groupOptions.saveLivecast = false
                    }
                    break
                default:
                    break
            }
            this.setButtonStatus();
        },
        getRegions () {
            let self = this;
            this.regions = [];
            server.postNoError('/getregionlist')
            .then((res) => {
                if (res.data.status == constants.STATUS_SUCCESS) {
                    let regionList = commonUtil.getAWSRegionList();
                    for (let region of res.data.regions) {
                        self.regions.push({regionName: region , displayName: regionList[region].regionName} );
                    }
                    self.regions.push({regionName: "AUTO" , displayName: "AUTO"} );
                    self.inputForm.region.value = self.regions[0].regionName;
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "getRegions", error);
            });
        },
        isVisibleGroupOption(optionName) {
            if (this.appData.basicContract.planType == constants.LICENSE_PLAN_SEPARATE) {
                return commonUtil.isVisibleGroupOption(this.appData.onlinePurchase, optionName);
            } else {
                return true;
            }
        },
        toggleAdvancedSettings() {
            this.isAdvancedSettingsVisible = !this.isAdvancedSettingsVisible;
            if (this.isAdvancedSettingsVisible) {
                    this.$nextTick(() => {
                    this.scrollToAdvancedSettings();
                });
            }
        },
        scrollToAdvancedSettings() {
            const modalBody = this.$refs.modalBody;
            const element = this.$refs.advancedSettings;
            if (modalBody && element) {
                const offsetTop = element.offsetTop;
                modalBody.scrollTo({ top: offsetTop, behavior: 'smooth' });
            }
        },
        enableDisconnectAlertGroup() {
            return (this.appData.tenantOption & constants.DISCONNECT_ALERT_GROUP);
        }
    },
    props: ['appData']
}
</script>
<style scoped>
.el-select.select-option-item {
    width: 225px;
}

.el-input-number {
    margin-left: 105px;
    width: 120px;
}

.language-option-container {
    padding: 12px 5px 12px 12px;
    margin-bottom: 20px;
    text-align: left;
    background-color: #f6f6f6;
    border-radius: 4px;
    color: rgb(132, 137, 145);
}

.language-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.language-title {
    text-align: left;
    font-size: 12px;
}

.engine-list {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.engine-item {
    flex-wrap: nowrap;
    border-bottom: 1px solid #EBEEF5;
    padding-bottom: 8px;
}

.engine-item:last-child {
    border-bottom: none;
}

.engine-name {
    white-space: normal;
    text-align: left;
    font-size: 12px;
    font-weight: 700;
    margin:0 10px 5px 40px;
    word-break: break-word;
}

.engine-name span {
    font-weight: 700;
}

.engine-description {
    white-space: normal;
    text-align: left;
    margin-left: 40px;
    font-size: 12px;
    margin-right: 10px;
    word-break: break-all;
}

.toggle-beside-line {
  color: #848991;
  font-size: 12px;
  display: flex;
  align-items: center;
  cursor: pointer; /* クリック可能であることを示す */
}
.toggle-beside-line:before, .toggle-beside-line:after {
  content: "";
  flex-grow: 1;
  height: 1px;
  background: #eee;
  display: block;
}

.toggle-beside-line:before {
  margin-right: .4em;
}

.toggle-beside-line:after {
  margin-left: .4em;
}

.toggle-arrow {
  margin-left: 8px;
  transition: transform 0.3s ease;
}

.toggle-arrow.open {
  transform: rotate(180deg);
}
</style>
